export default "__VITE_ASSET__0301cc7a__"